import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

// A plain project icon — no thumbnail box, just the icon itself (sized + colored
// via this wrapper, unlike GoalInsightsCard's boxed ImageContainer).
export const ProjectIcon = styled.span<{ $color?: string }>`
  display: flex;
  align-items: center;

  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ $color, theme }) => $color ?? theme.palette.grey[700]};
`;

export const TitleContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  min-width: 0;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  min-width: 0;
`;

export const ParentName = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  min-width: 0;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
